import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Tooltip from 'src/Components/Tooltip';
import { TooltipPosition } from 'src/Components/Tooltip/types';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import { StakingPlan } from 'src/models';
import icArrowUp from 'assets/svg/ic_arrow_up_blue.svg';
import RadioButton from 'src/Components/RadioButton';

const TimeLockChoosing = ({
  planStake,
  est,
  setPlanStake
}) => {
  const [collapsed, setCollapsed] = React.useState(true);

  const renderTooltipTimeLock = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltip, styles.tooltipTimelock)
    }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "2 staking options: 6 months & 12 months"), /*#__PURE__*/React.createElement("li", null, "You can unstake after the due date")));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header,
    onClick: () => setCollapsed(!collapsed)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Staking Plan"), /*#__PURE__*/React.createElement(Tooltip, {
    content: renderTooltipTimeLock(),
    position: TooltipPosition.BOTTOM,
    color: "#3C32AF"
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, planStake == StakingPlan.SIX_MONTHS ? `6 months / ${est[StakingPlan.SIX_MONTHS]}%` : `12 months / ${est[StakingPlan.ONE_YEAR]}%`), /*#__PURE__*/React.createElement("img", {
    src: icArrowUp,
    className: classNames(styles.icArrow, collapsed && styles.collapsed)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content, collapsed && styles.collapsed, styles.fullWidth)
  }, /*#__PURE__*/React.createElement("label", {
    className: classNames(styles.radioChoosing, planStake == StakingPlan.SIX_MONTHS ? styles.active : null),
    htmlFor: "stake-plan-6"
  }, /*#__PURE__*/React.createElement(RadioButton, {
    type: "radio",
    value: StakingPlan.SIX_MONTHS,
    onClick: () => setPlanStake(StakingPlan.SIX_MONTHS),
    name: "stake",
    defaultChecked: planStake == StakingPlan.SIX_MONTHS,
    id: "stake-plan-6"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.time
  }, "6 months"), /*#__PURE__*/React.createElement("span", null, est[StakingPlan.SIX_MONTHS], "%")), /*#__PURE__*/React.createElement("label", {
    className: classNames(styles.radioChoosing, planStake == StakingPlan.ONE_YEAR ? styles.active : null),
    htmlFor: "stake-plan-12"
  }, /*#__PURE__*/React.createElement(RadioButton, {
    type: "radio",
    value: StakingPlan.ONE_YEAR,
    name: "stake",
    onClick: () => setPlanStake(StakingPlan.ONE_YEAR),
    defaultChecked: planStake == StakingPlan.ONE_YEAR,
    id: "stake-plan-12"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.time
  }, "12 months"), /*#__PURE__*/React.createElement("span", null, est[StakingPlan.ONE_YEAR], "%"))));
};

export default TimeLockChoosing;